

const Circle = () => {
  return (
    <div className='circle-Head'>
        <div className='ping1'></div>
    </div>
  )
}

export default Circle